export default {
	standardSiteWidth: 1320,
	borderRadius: {
		standard: 16,
		small: 12,
		xsmall: 8,
	},
	mediaQuery: {
		breakpointSm: '@media (min-width: 640px)' /* 640px */,
		breakpointMd: '@media (min-width: 768px)' /* 768px */,
		breakpointLg: '@media (min-width: 1024px)' /* 1024px */,
		breakpointXl: '@media (min-width: 1280px)' /* 1280px */,
		breakpoint2xl: '@media (min-width: 1536px)' /* 1536px */,
	},
	fonts: {
		heading: 'ITCGaramondStdBookCondensed, Georgia, serif',
		subheadingRegular: 'NeueMontreal-Regular, Arial, sans-serif', // font-weight 400
		subheadingMedium: 'NeueMontreal-Medium, Arial, sans-serif', // font-weight 500
		callout600: 'SpeziaSemiMono_600, Courier New, monospace',
		body: 'STKBureauSans-Book, Arial, sans-serif',
		bodyItalic: 'STKBureauSans-BookItalic, Arial, sans-serif',
	},
	colors: {
		white: {
			main: '#ffffff',
			mid: '#CACED5',
			secondary: '#f5f7f8',
			dark: '#d1d5db',
			rgb: '255, 255, 255',
		},
		black: {
			main: '#060f24',
			rgb: '6, 15, 36',
		},
		navy: {
			main: '#071E46',
		},
		cream: {
			main: '#F6F2F0',
			dark: '#E2D6CF',
			200: '#E2D6CF',
			300: '#CFBAAF',
			800: '#503A30',
		},
		primary: {
			main: '#FC5B30', // submittable orange
			dark: '#c93007',
		},
		grey: {
			grey1: '#CACED5',
		},
		secondary: {
			main: '#2E73EB',
			light: '#C8DCF9',
			rgb: '46, 115, 235',
			100: '#DCE6F9',
			200: '#B9D0F8',
			800: '#0B3274',
		},
		tertiary: {
			main: '#C652AB',
			800: '#601F51',
		},
		quaternary: {
			main: '#00A9B3',
			800: '#00484D',
		},
		custom: {
			whySubmittable: {
				cream: '#F4F3EF',
				white: '#F8F4E9',
				white_rgb: '248, 244, 233',
				green: '#5E6C4B',
				darkGreen: '#495638',
				creamGreen: '#868D76',
				blue: '#E0E5E0',
				darkBlue: '#D5DDD8',
				yellow: '#EFA20F',
			},
			ai: {
				white: '#F2F0EE',
				black: '#0A1322',
			},
			resourceHub: {
				white: '#F3F1E6',
				black: '#131E33',
				grey: '#9A9BA0',
				tan: '#F3EEEE',
			},
		},
		customGradients: {
			ctaGradient: 'linear-gradient(135deg, #EAF0FC, #F9EDF5)',
			twoColumnHero:
				'linear-gradient(45deg,rgba(251, 243, 249, 1) 0%, rgba(239, 240, 252, 1) 48%, rgba(247, 240, 249, 1) 100%);',
			compareGradientDark:
				'linear-gradient(90deg, rgba(57,78,116,1) 0%, rgba(22,33,54,1) 26%, rgba(22,33,54,1) 74%, rgba(57,78,116,1) 100%)',
			compareGradientLight:
				'linear-gradient(262deg, rgba(140,138,173,1) 0%, rgba(107,131,189,1) 52%, rgba(140,138,173,1) 100%)',
			screenshotGradient:
				'radial-gradient(90% 90% at 70% 100%, #C4B8E4 20%, #E4CDE3 78%, #E6E2ED6B 100%),linear-gradient(0deg, #E4CDE3 0%, #F5F0EF 100%)',
		},
	},
	fixedHeights: {
		announcementBar: 42,
		navBar: 76,
	},
};
